import React from 'react';
import PropTypes from 'prop-types';

export default function EncounterIcon(props) {
  return (
      <svg width="36" height="36" viewBox="0 0 36 36" className={props.className}>
        <path fill="#a4b0bf" fillRule="nonzero" d="M25.54 16.5l1.854-1.853v11.746c0 1.024-.83 1.854-1.854 1.854H8.854A1.853 1.853 0 0 1 7 26.393V9.707c0-1.024.83-1.854 1.854-1.854h15.455l-5.562 5.562H8.854v12.978H25.54V16.5zm4.595-7.216l-2.318-2.318.487-.486a1.64 1.64 0 0 1 2.317 2.317l-.486.487zm-3.629-1.007l2.318 2.318-9.796 9.796-2.758.44.44-2.758 9.796-9.796z"/>
      </svg>
  );
}

EncounterIcon.propTypes = {
  className: PropTypes.string,
};

EncounterIcon.defaultProps = {
  className: null,
};



// WEBPACK FOOTER //
// ./src/components/controls/icons/EncountersIcon.jsx